import React from 'react';

const PublicationView = () => {
	return ( <p>PublicationView</p> );
}
 
export default PublicationView;